import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=34f9914a"
import script from "./PromoBanner.vue?vue&type=script&lang=ts"
export * from "./PromoBanner.vue?vue&type=script&lang=ts"
import style0 from "./PromoBanner.vue?vue&type=style&index=0&id=34f9914a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports